<template>
  <div v-if="mostrarBanner" class="cookie-banner">
    <div class="cookie-content">
      <div class="cookie-text">
        <p>
          Este site utiliza cookies para melhorar sua experiência de navegação. 
          Ao continuar navegando, você concorda com nossa 
          <a href="/doc/POL0007R01_PC.pdf" target="_blank" class="cookie-link">Política de Cookies</a> 
          e nossa 
          <a href="/doc/POL0006R02_PP.pdf" target="_blank" class="cookie-link">Política de Privacidade</a>.
        </p>
      </div>
      <div class="cookie-actions">
        <button @click="aceitarCookies" class="btn-aceitar">
          Aceitar
        </button>
        <button @click="recusarCookies" class="btn-recusar">
          Recusar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      mostrarBanner: false
    }
  },
  mounted() {
    // Verificar se o usuário já aceitou ou recusou os cookies
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      this.mostrarBanner = true
    }
  },
  methods: {
    aceitarCookies() {
      localStorage.setItem('cookieConsent', 'accepted')
      this.mostrarBanner = false
    },
    recusarCookies() {
      localStorage.setItem('cookieConsent', 'rejected')
      this.mostrarBanner = false
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 2px solid #34894d;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 20px;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.cookie-text {
  flex: 1;
  min-width: 300px;
}

.cookie-text p {
  margin: 0;
  color: #374151;
  font-size: 14px;
  line-height: 1.6;
}

.cookie-link {
  color: #34894d;
  text-decoration: underline;
  font-weight: 500;
  transition: color 0.2s;
}

.cookie-link:hover {
  color: #2d7a42;
}

.cookie-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.btn-aceitar {
  background: #34894d;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-aceitar:hover {
  background: #2d7a42;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(52, 137, 77, 0.2);
}

.btn-recusar {
  background: transparent;
  color: #6b7280;
  border: 2px solid #d1d5db;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-recusar:hover {
  border-color: #9ca3af;
  color: #374151;
  background: #f9fafb;
}

@media (max-width: 768px) {
  .cookie-content {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-actions {
    width: 100%;
    justify-content: stretch;
  }

  .btn-aceitar,
  .btn-recusar {
    flex: 1;
  }

  .cookie-text {
    min-width: 100%;
  }
}
</style>

